import { useEffect, useRef } from "react";
import { useLocation, useHistory } from "react-router-dom";
import Hls from "hls.js";
import "./TutorVideo.scss";
import images from "../../../../../../utilities/images/images";
import Header_component from "../../../../structure_components/desktop_screens/header_component/header_component";
import Footer_component from "../../../../structure_components/desktop_screens/footer_component/Footer_component";

const TutorVideo = () => {
  const location = useLocation();
  const history = useHistory();
  const videoData = location.state?.videoData;
  const videoRef = useRef(null);

  useEffect(() => {
    if (!videoData) return;

    const video = videoRef.current;
    const videoSrc = videoData?.video?.url;

    if (Hls.isSupported()) {
      const hls = new Hls();
      hls.loadSource(videoSrc);
      hls.attachMedia(video);
      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        video.play().catch((error) => {
          console.error("Error playing video:", error);
        });
      });

      return () => {
        hls.destroy();
      };
    } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = videoSrc;
      video.play().catch((error) => {
        console.error("Error playing video:", error);
      });
    }
  }, [videoData?.video.url]);

  if (!videoData) {
    history.push("/history");
    return null;
  }

  // Simple date conversion function
  const convertDate = (videoData) => {
    const date = new Date(videoData);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  // Convert callTime from milliseconds to mm:ss format
  const formatDuration = (callTime) => {
    const totalSeconds = Math.round(callTime / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
  };

  const handleBackClick = () => {
    history.push("/doubts");
  };

  return (
    <>
      <Header_component />
      <div className="video-player-page">
        <div className="video-player-content">
          <div className="video-player-header">
            <button className="back-btn" style={{ display: "flex" }}>
              <img
                src={images.leftArrow}
                alt="Back"
                style={{ width: "38px", height: "38px", cursor: "pointer" }}
                onClick={handleBackClick}
              />
              <h2 className="video-title">{videoData.topics.join(", ")}</h2>
            </button>
          </div>
          <div className="video-container">
            <video
              ref={videoRef}
              className="video-element"
              controls
              poster={videoData.video.thumbnail}
            />
          </div>
          <div
            className="video-details"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div>
              <h2 className="video-title">{videoData.topics.join(", ")}</h2>
              <p className="video-question">{videoData.questionText}</p>
            </div>
            <div className="video-meta">
              <span className="date">
                <img
                  src={images.timer}
                  alt=""
                  style={{ width: "16px", height: "16px" }}
                />
                {convertDate(videoData.date)}
              </span>
              <span className="duration">
                <img
                  src={images.time}
                  alt=""
                  style={{ width: "16px", height: "16px", marginRight: "5px" }}
                />
                {formatDuration(videoData.callTime)}
              </span>
            </div>
          </div>
          <div className="instructor-info" style={{ marginBottom: "9px" }}>
            <span>Taught By</span>
          </div>
          <div className="instructor-details">
            <img
              src={videoData.instructor.profileImage}
              alt={videoData.instructor.name}
              className="instructor-image"
            />
            <span className="instructor-name">{videoData.instructor.name}</span>
          </div>
          <h5 style={{ marginTop: "9px" }}>Notes and attachment</h5>
          <div className="notes-section">
            <div className="notes-content">
              <h4>Class Notes</h4>
              <img
                src={videoData.notes.thumbnail}
                alt="Notes Thumbnail"
                className="notes-thumbnail"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  history.push("/pdfview", {
                    videoData, // Pass the entire videoData object
                  })
                }
              />
            </div>
          </div>
        </div>
      </div>
      <Footer_component />
    </>
  );
};

export default TutorVideo;
